import { Tab, Tabs } from '@mui/material';
import { useState } from 'react';
import TransactionStatus from '../TransactionStatus';
import Password from './Password';
import PropTypes from 'prop-types';
import { useJunoCommonFunctions } from '../../../client/Juno/helpers';
import JunoModal from '../common/JunoModal'; 

const TAB_LABELS = ['Personal Info', 'Password'];

const EditProfile = ({ open, onClose }) => {
    const [activeTab, setActiveTab] = useState(0);
    const [success, setSuccess] = useState(false);
    const { logout } = useJunoCommonFunctions();

    return (
        <>
            {!success ? (
                <JunoModal
                    title={'edit personal information'}
                    open={open}
                    onClose={onClose}
                    showBack={true}
                    fullScreenMobile={true}
                    content={() => (
                        <div className="md:px-0 bg-modal-bg md:bg-transparent h-full md:h-auto relative">
                            <Tabs className="bg-card-bg mt-4 mb-9 rounded-lg outline outline-[0.50px] outline-black/5 p-0.5">
                                {TAB_LABELS.map((tab, index) => (
                                    <Tab
                                        key={index}
                                        label={tab}
                                        wrapped
                                        onClick={() => {
                                            setActiveTab(index);
                                        }}
                                        sx={{
                                            flexGrow: 1,
                                            minWidth: activeTab === index ? 50 : 'auto',
                                            maxWidth: '50%',
                                            width: '50%',
                                            borderRadius: '7px',
                                            background:
                                                activeTab === index ? '#FCFCFC' : 'transparent',
                                            color:
                                                activeTab === index
                                                    ? '#18181B'
                                                    : 'var(--balance-manage-text)',
                                            fontWeight: 500,
                                            fontSize: '14px',
                                            fontFamily: 'Inter',
                                            lineHeight: '20px',
                                            paddingX: '16px',
                                            height: '10px',
                                            boxShadow:
                                                activeTab == index
                                                    ? '0px 3px 1px 0px rgba(0, 0, 0, 0.04), 0px 3px 8px 0px rgba(0, 0, 0, 0.12);'
                                                    : '',
                                        }}
                                    />
                                ))}
                            </Tabs>
                            {activeTab == 0 ? (
                                <div className="self-stretch relative top-[25%] md:top-0 md:h-80 md:pt-16 inline-flex flex-col justify-center md:justify-start items-center gap-4 ">
                                    <div className="text-center justify-center !text-primary text-base font-semibold uppercase leading-normal">
                                        Edit Personal Info
                                    </div>
                                    <div className="self-stretch text-center justify-start text-profile-text-muted text-sm font-medium uppercase leading-tight">
                                        To update your account information, please contact our
                                        customer support team at:
                                    </div>
                                    <div className="text-center justify-center !text-primary text-lg font-medium underline lowercase leading-7">
                                        support@junomoney.com
                                    </div>
                                </div>
                            ) : null}
                            {activeTab == 1 ? (
                                <Password onClose={onClose} setSuccess={setSuccess} />
                            ) : null}
                        </div>
                    )}
                />
            ) : (
                <TransactionStatus
                    description={'password changed sucessfully'}
                    onClick={() => {
                        logout(); 
                    }}
                />
            )}
        </>
    );
};

EditProfile.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
};

export default EditProfile;
